import { useAppSelector } from '../../stores/store';
import { PlayerUITopBar } from './PlayerUITopBar';
import { PlayerUIBottomBar } from './PlayerUIBottomBar';
import { PlayerUIControl } from './PlayerUIControl';
import PlayerUIBottomBarMobile from "./Mobile/PlayerUIBottomBarMobile.tsx";
import EpgPageXDetailsModal from '../test/EpgPageXDetailsModal.tsx';
import { IPlayerChannel } from '../../interfaces/IPlayerUIState.ts';
import { IChannel } from '../../interfaces/IChannel.ts';

const PlayerUI = () => {
    // useAxiosInterceptor();
    const isMenuUIVisible = useAppSelector((state) => state.playerUI.isMenuUIVisible);
    const channels = useAppSelector((state) => state.playerUI.channels);
    const getChannels = (playerChannels: IPlayerChannel[]): IChannel[] => {
        return playerChannels.map((channel) => ({ ch_id: channel.ch_id, cmd: channel.cmd, enabled: channel.enabled, epgList: channel.epgList, genre_id: -1, genre_name: "", logo: channel.logo, name: channel.name, position: -1 } as IChannel));
    };
    return (
        <div className={`${isMenuUIVisible ? "sm:opacity-100" : "sm:opacity-0"} h-full transition-opacity duration-500`}>
            <PlayerUITopBar />
            <PlayerUIControl />
            <PlayerUIBottomBar channels={channels} />
            <PlayerUIBottomBarMobile channels={channels} />
            <EpgPageXDetailsModal channels={getChannels(channels)} />
        </div>
    )
}

export default PlayerUI;